var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { trimEndSlash, getTokenRequestParameters, parseAuthAPIResponse } from "../../helpers";
import { WALLET_ENDPOINTS, RequestMethods } from "../../constants";
export class WalletRequestService {
    constructor(baseApiUrl, ajaxService, domainID, makeTokenRequest) {
        this.baseApiUrl = baseApiUrl;
        this.ajaxService = ajaxService;
        this.domainID = domainID;
        this.makeTokenRequest = makeTokenRequest;
    }
    getAnonymousToken() {
        const url = `${trimEndSlash(this.baseApiUrl)}/${WALLET_ENDPOINTS.ANONYMOUS}`;
        const options = this.getRequestProperties(JSON.stringify({
            DomainId: this.domainID
        }));
        const parameters = getTokenRequestParameters(url, parseAuthAPIResponse, options);
        return this.makeTokenRequest(this.ajaxService, parameters);
    }
    getRenewedToken(token) {
        const url = `${trimEndSlash(this.baseApiUrl)}/${WALLET_ENDPOINTS.RENEW}`;
        const options = this.getRenewRequestOptions(token);
        const parameters = getTokenRequestParameters(url, parseAuthAPIResponse, options);
        return this.makeTokenRequest(this.ajaxService, parameters);
    }
    getRenewRequestOptions(token) {
        return {
            body: JSON.stringify({
                token
            }),
            headers: {
                authorization: `Bearer ${token}`
            },
            method: RequestMethods.POST
        };
    }
    getLoginRequestBody(params) {
        const body = {
            token: params.token,
            DomainId: this.domainID.toString()
        };
        return JSON.stringify(body);
    }
    getLoginToken(params) {
        const url = `${trimEndSlash(this.baseApiUrl)}/${WALLET_ENDPOINTS.LOGIN}`;
        const options = this.getRequestProperties(this.getLoginRequestBody(params));
        const parameters = getTokenRequestParameters(url, parseAuthAPIResponse, options);
        return this.makeTokenRequest(this.ajaxService, parameters);
    }
    getRequestProperties(body) {
        return {
            body,
            method: RequestMethods.POST
        };
    }
    logout(token) {
        return __awaiter(this, void 0, void 0, function* () {
        });
    }
}
//# sourceMappingURL=WalletRequestService.js.map